import React from 'react';
import { Box, Button, Grid, Typography, Paper, Link } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

import FileUploadBox from './FileUploadBox';


const FileUploadSection = ({
  templateFile,
  setTemplateFile,
  templateFileError,
  existingTemplateFileName,
  existingTemplateFileUrl,
  itemListTemplateFile,
  setItemListTemplateFile,
  itemListTemplateFileError,
  existingItemListTemplateFileName,
  existingItemListTemplateFileUrl,
  logoFile,
  setLogoFile,
  logoFileError,
  existingLogoFileName,
  existingLogoFileUrl,
  receiptTemplate,
  itemTemplate,
  onParseReceiptTemplate,
  onParseItemTemplate,
}) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={4}>
        <FileUploadBox
          label="Logo"
          file={logoFile}
          onFileChange={setLogoFile}
          error={logoFileError}
          existingFileName={existingLogoFileName}
          existingFileUrl={existingLogoFileUrl}
          inputId="logo-upload"
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <FileUploadBox
          label="Receipt Template"
          file={templateFile}
          onFileChange={setTemplateFile}
          error={templateFileError}
          existingFileName={existingTemplateFileName}
          existingFileUrl={existingTemplateFileUrl}
          inputId="template-upload"
        />
        <Box mt={1} textAlign="center">
          <Button
            variant="outlined"
            size="small"
            onClick={onParseReceiptTemplate}
            disabled={!receiptTemplate}
            startIcon={<CloudUploadIcon />}
          >
            Populate Dynamic Configuration Table
          </Button>
        </Box>
      </Grid>

      <Grid item xs={12} md={4}>
        <FileUploadBox
          label="Item List Template"
          file={itemListTemplateFile}
          onFileChange={setItemListTemplateFile}
          error={itemListTemplateFileError}
          existingFileName={existingItemListTemplateFileName}
          existingFileUrl={existingItemListTemplateFileUrl}
          inputId="itemlist-upload"
        />
        <Box mt={1} textAlign="center">
          <Button
            variant="outlined"
            size="small"
            onClick={onParseItemTemplate}
            disabled={!itemTemplate}
            startIcon={<CloudUploadIcon />}
          >
            Populate Item List Configuration Table
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default FileUploadSection;
